import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import { EVENTS, isObjectEmpty, tryParse } from "@/utils";
import { CSV_EXPORT_ROW_LIMIT, FILTER_KEYS } from "@/utils/constants";
import Filter from "@/store/filter";
import { FilterManager } from "@/store/filter";
import moment from "moment";
import AppInput from "@/components/AppInput";
import AppPagination from "@/components/AppPagination";
import PricingAndMarginTopSection from "@/components/pricingandmargin/PricingAndMarginTopSection";
import PricingAndMarginExportDropDown from "@/components/pricingandmargin/PricingAndMarginExportDropDown";
import PricingAndMarginDataContent from "@/components/pricingandmargin/PricingAndMarginDataContent";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import PricingAndMarginMixin from "@/mixins/PricingAndMarginMixin.vue";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin.vue";
import ErrorOccured from "@/components/shared/ErrorOccured.vue";
import { localStorageSetItem } from "@/utils/storage";
export default {
  name: "PricingAndMarginPageV2",
  mixins: [AccountsMixin, DownloadMixin, PricingAndMarginMixin, DownloadMixin, InitializeFiltersMixin],
  components: {
    AppInput,
    AppPagination,
    ErrorOccured,
    PricingAndMarginTopSection,
    PricingAndMarginExportDropDown,
    PricingAndMarginDataContent
  },
  data() {
    return {
      dataLoading: true,
      errorOccured: false,
      isDownloadRunning: false,
      openModal: false,
      page: 1,
      perPage: 20,
      search: "",
      sortField: "revenue_share_sku_marketplace_seller_id_last_28d",
      sortDirection: "desc",
      keyword_list: [],
      sellers: [],
      marketplaces: [],
      selected: [],
      currentSettings: {},
      sortValueForKey: {
        revenue_share_sku_marketplace_seller_id_last_28d: item => Number(item.revenue_share_sku_marketplace_seller_id_last_28d ?? 0)
      }
    };
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
      pricing_and_margin_data: state => state.pricing_and_margin.list,
      pricing_and_margin_data_download: state => state.pricing_and_margin.download_list,
      sellers_filter: state => state.pricing_and_margin.sellers_filter,
      marketplaces_filter: state => state.pricing_and_margin.marketplaces_filter,
      products_filter: state => state.pricing_and_margin.products_filter,
      segments_filter: state => state.pricing_and_margin.segments_filter,
      filterManager: state => state.pricing_and_margin.filterManager,
      total_rows: state => state.pricing_and_margin.total_rows,
      current_workspace: state => state.workspace.current_workspace,
      isOmnyWorkspace: state => state.workspace.isOmnyWorkspace
    }),
    ...mapGetters(["pricingAndMarginSellersListGet", "pricingAndMarginMarketPlacesListGet", "pricingAndMarginProductsGetSkus", "pricingAndMarginProductsGetAsins"]),
    currentSellerIds() {
      return this.sellers_filter.filterItems.map(seller => seller.id);
    },
    dataLoadingDf() {
      return this.dataLoading;
    },
    pmDataInitialized() {
      return !isObjectEmpty(this.pricing_and_margin_data);
    },
    dfFiltered() {
      //console.log("[pricing and margin data in dfFiltered]");
      //console.log(this.pricing_and_margin_data);

      return this.pricing_and_margin_data.sort((a, b) => {
        const aValue = this.sortValueForKey[this.sortField](a);
        const bValue = this.sortValueForKey[this.sortField](b);
        if (this.sortDirection === "asc") {
          return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        } else if (this.sortDirection === "desc") {
          return bValue < aValue ? -1 : bValue > aValue ? 1 : 0;
        }
        return 0;
      }).filter(item => {
        const s = this.search.trim().toLowerCase();
        if (s != "") {
          return item?.sku?.toLowerCase().includes(s) || item?.asin?.toLowerCase().includes(s) || item?.product_name?.toLowerCase().includes(s) || item?.external_sku?.toLowerCase().includes(s);
        }
        return true;
      });
    },
    selectedFilteredSkus() {
      return this.selected.filter(sku => {
        return this.dfFiltered.find(el => el.sku == sku && el);
      });
    },
    selectedFilteredItems() {
      return this.dfFiltered.filter(item => this.selected.includes(item.sku));
    }
  },
  async mounted() {
    var is_authenticated = await this.authStatus();
    if (is_authenticated) {
      await this.initializeSellersFilter(this.pricingMarginSellersFilterSet);
      await this.initializeMarketplacesFilter(this.pricingMarginMarketplacesFilterSet, true);
      this.marketplaces_filter._key = "sales_channel";
      await this.initializeProductsFilters({
        sellers: this.sellers_filter.filterValues,
        sales_channel: this.marketplaces_filter.filterValues
      }, this.products_filter, "inventory/pricing_and_margin");
      const filterManager = new FilterManager({
        sellersFilter: this.sellers_filter,
        marketplacesFilter: this.marketplaces_filter,
        rootPath: "inventory/pricing_and_margin"
      });
      const secondaryFilters = {
        [FILTER_KEYS.PRODUCTS]: {
          storeFilter: this.products_filter,
          initializer: this.initializeProductsFilters
        },
        [FILTER_KEYS.SEGMENTS]: {
          storeFilter: this.segments_filter,
          initializer: this.initializeSegmentsFilter
        }
      };
      filterManager.registerAll(secondaryFilters);
      this.$store.dispatch('pricingMarginSetFilterManager', filterManager);
      filterManager.refreshAllBackground();
      await this.refreshPricingAndMarginContent();
      window.$bus.on(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE, this.refreshPricingAndMarginContent);
      window.$bus.on(EVENTS.REFRESH_PRICING_AND_MARGIN_SELLERS_SUB_FILTERS, async v => await this.refreshPricingAndMarginSellersSubFilters(v));
      window.$bus.on(EVENTS.REFRESH_PRICING_AND_MARGIN_MARKETPLACES_SUB_FILTERS, async () => this.refreshPricingAndMarginMarketplacesSubFilters());
      window.$bus.on(EVENTS.REFRESH_PRICING_AND_MARGIN_PRODUCTS_SUB_FILTERS, () => this.refreshPricingAndMarginProductsSubFilters());
    }
  },
  // async created(){

  // },
  methods: {
    ...mapMutations(["pricingMarginSellersFilterSet", "pricingMarginMarketplacesFilterSet", "pricingMarginDataKeywordsListSet"]),
    ...mapActions(["authStatus", "pricingAndMarginGetByFilters", "pricingAndMarginGetByFiltersToDownload"]),
    async refreshPricingAndMarginContent() {
      try {
        //console.log("[refreshPricingAndMarginContent]");
        this.dataLoading = true;
        const seller_list = this.pricingAndMarginSellersListGet();
        const asin_list = this.pricingAndMarginProductsGetAsins();
        const sku_list = this.pricingAndMarginProductsGetSkus();
        if (seller_list.length > 0) {
          const market_places_list = this.pricingAndMarginMarketPlacesListGet();
          let result = await this.pricingAndMarginGetByFilters({
            seller_list: seller_list,
            asin_list: asin_list,
            sku_list: sku_list,
            page_offset: this.page,
            page_limit: this.perPage,
            keyword_list: this.keyword_list,
            sales_channel: market_places_list
          });
          this.throwIfError(result);
        }
        this.dataLoading = false;
        this.errorOccured = false;
      } catch (error) {
        this.dataLoading = false;
        this.errorOccured = true;
      }
    },
    async changePage(newPage) {
      this.page = newPage;
      await this.refreshPricingAndMarginContent();
    },
    async changeElements(elementsPerPage) {
      this.page = 1;
      this.perPage = elementsPerPage;
      await this.refreshPricingAndMarginContent();
    },
    sortByObjectValue(obj) {
      return obj[this.sortField];
    },
    onSort(values) {
      this.sortField = values[0];
      this.sortDirection = values[1];
    },
    async searchItem($event) {
      let keyword_list = $event.toLowerCase().split(",").filter(v => !!v).map(element => element.trim());
      this.pricingMarginDataKeywordsListSet(keyword_list);
      this.saveKeyWordListToCache(keyword_list);
      window.$bus.trigger(EVENTS.REFRESH_PRICING_AND_MARGIN_DATA_PAGE);
    },
    saveKeyWordListToCache(keyword_list) {
      let current_workspace = tryParse(localStorage.getItem("current_workspace"));
      if (!isObjectEmpty(current_workspace)) {
        localStorageSetItem(current_workspace.workspace_id + "pricingMarginDataKeywordsListSet" + "keywords_list_filter", JSON.stringify(keyword_list));
      }
    },
    async handleSelectionDownloadTypeCSV() {
      //console.log("[downloading CSV for Pricing and Margin Page]");
      try {
        let headersMapping = {
          sales_channel: "sales_channel",
          sku: "sku",
          ASIN: "asin",
          product_name: "product_name",
          buybox_status: "buybox_status",
          buybox_price: "buybox_price",
          price: "price",
          margin: "margin_ccy",
          tax: "tax_est",
          referral: "fees_estimate",
          fulfilmment_program: "fulfilmment_program",
          fba: "fba_fees",
          prep: "prep_fees",
          cogs: "wholesale_ccy",
          currency: "currency"
        };
        let csv_headers = this.extractHeaders(headersMapping);
        this.seller_list = this.pricingAndMarginSellersListGet();
        if (!this.seller_list.length) {
          this.throwIfError({});
        }
        window.$bus.trigger("showSuccess", {
          visible: true,
          message: "CSV download request initiated successfully.",
          delay: 5999 // Show alert less than 1 minute
        });
        let fileName = "pricing_and_margin__data_" + this.seller_list.join("_") + "_" + moment().format("YYYY_MM_DD").toString() + ".csv";

        // Function to fetch data in chunks/pages and accumulate CSV content
        const totalPages = this.totalPagetoDownload();
        let csv_string = await this.generateCsvStringWithPagination(csv_headers, totalPages, this.downloadPricingandMarginDataRows);
        this.throwIfError(csv_string);
        this.downloadCsv(csv_string, fileName);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: "Error generating or downloading CSV" + error,
          visible: true,
          delay: 10
        });
      }
    },
    async downloadPricingandMarginDataRows(currentPage) {
      const seller_list = this.pricingAndMarginSellersListGet();
      if (seller_list.length > 0) {
        const market_places_list = this.pricingAndMarginMarketPlacesListGet();
        let result = await this.pricingAndMarginGetByFiltersToDownload({
          seller_list: seller_list,
          page_offset: currentPage,
          page_limit: CSV_EXPORT_ROW_LIMIT,
          keyword_list: this.keyword_list,
          sales_channel: market_places_list
        });
        this.throwIfError(result);
      }
      return this.pricing_and_margin_data_download;
    },
    totalPagetoDownload() {
      return Math.ceil(this.total_rows / CSV_EXPORT_ROW_LIMIT); //this.perPage
    },
    extractHeaders(headersMapping) {
      // Ensure data is valid and not empty
      return Object.fromEntries(new Map(
      //Object.entries(headersMapping).map((fieldName) => [fieldName, fieldName])
      Object.entries(headersMapping).map(([key, value]) => [key, value])));
    },
    async refreshPricingAndMarginSellersSubFilters(check_local_storage) {
      await this.initializeMarketplacesFilter(this.pricingMarginMarketplacesFilterSet, check_local_storage);
      this.marketplaces_filter._key = "sales_channel";
      await this.filterManager.refreshAll();
    },
    async refreshPricingAndMarginMarketplacesSubFilters() {
      await this.filterManager.refreshSet([FILTER_KEYS.PRODUCTS]);
    },
    async refreshPricingAndMarginProductsSubFilters() {
      const segment_list = this.segments_filter.selected.map(({
        segment
      }) => segment).filter(Boolean);
      await this.filterManager.refreshSet([FILTER_KEYS.PRODUCTS], {
        segment_list
      });
    },
    handleErrorOccured() {
      //console.log("[no account]");
    }
  }
};